import * as d3 from 'd3'
export default {

  methods: {

    draw_Area() {

      let summary = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.area.x}, ${this.area.y})`)

      summary 
      .append('text')
      .attr('id', `AREA_MAIN_${this.localId}`)
      .attr('x', 0).attr('y', -4).attr('opacity', 1)
      .attr('fill', '#333').attr('font-size', 13).attr('text-anchor', 'start')
      .text('Overall')

      summary 
      .append('text')
      .attr('id', `AREA_TEMP_${this.localId}`)
      .attr('x', 0).attr('y', -4).attr('opacity', 0)
      .attr('fill', '#333').attr('font-size', 13).attr('text-anchor', 'start')
      .text('Overall')

      summary 
      .append('text')
      .attr('id', `AREA_SUB_${this.localId}`)
      .attr('x', this.getNode(`#AREA_MAIN_${this.localId}`) + 5).attr('y', -4)
      .attr('fill', '#757575').attr('font-size', 9).attr('text-anchor', 'start')
      .text('Progress by Area')

      summary
      .append('rect')
      .attr('x', 0).attr('y', 0)
      .attr('width', (this.area.barLen*3) + (this.area.padding*6)).attr('height', 75)
      .attr('fill', '#F4F5F5').attr('fill-opacity', 0.5).attr('rx', 3)
      .attr('stroke', '#E0E0DF').attr('stroke-width', .5)
      
      let x_ = (this.area.barLen*1) + (this.area.padding*2)
      this.gmx_Line(summary, x_, x_, 10, 65, '#E0E0DF', .5, 1)

      x_ = (this.area.barLen*2) + (this.area.padding*4)
      this.gmx_Line(summary, x_, x_, 10, 65, '#E0E0DF', .5, 1)


      x_ = this.area.padding
      this.area.cols.forEach(col=> {
        col.plan   = this.areaData.find(f=> f.PHASE == this.currnet.phase && f.AREA == col.name).PLAN
        col.actual = this.areaData.find(f=> f.PHASE == this.currnet.phase && f.AREA == col.name).ACTUAL
        col.delta  = this.areaData.find(f=> f.PHASE == this.currnet.phase && f.AREA == col.name).DELTA

        this.draw_BarChart(summary, x_, col)
        x_ += this.area.barLen + (this.area.padding*2)
      })

    },


    draw_BarChart(selection, x_ , col) {

      let title = selection
      .append('g')
      .attr('transform', `translate(${x_}, ${17})`)

      title 
      .append('text')
      .attr('x', 0).attr('y', 0)
      .attr('fill', '#333').attr('font-size', 12).attr('text-anchor', 'start')
      .text(col.name)

      title 
      .append('text')
      .attr('class', 'PHASE')
      .attr('x', 0).attr('y', 10)
      .attr('fill', '#757575').attr('font-size', 9).attr('text-anchor', 'start')
      .text('Overall')

      let bar = selection
      .append('g')
      .attr('transform', `translate(${x_}, ${58})`)

      let barLen = (this.area.barLen/100) * col.actual
      bar
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('rx', 3)
      .attr('width', this.area.barLen).attr('height', 6)
      .attr('fill', '#E0E0DF').attr('stroke-width', 0)
      .attr('opacity', .5)

      bar
      .append('rect')
      .attr('id', `BAR_${col.name}_${this.localId}`)
      .attr('x', 0).attr('y', 0).attr('rx', 3)
      .attr('width', barLen).attr('height', 6)
      .attr('fill', col.color).attr('stroke-width', 0).attr('opacity', .75)

      // Actual
      bar 
      .append('text')
      .attr('id', `ACT_${col.name}_${this.localId}`)
      .attr('x', 0).attr('y', -12)
      .attr('fill', '#000').attr('font-size', 13).attr('text-anchor', 'start')
      .text(col.actual+'%')

      bar 
      .append('text')
      .attr('x', 1).attr('y', -3)
      .attr('fill', '#757575').attr('font-size', 8).attr('text-anchor', 'start')
      .text('Cumulative')

      // Plan
      bar 
      .append('text')
      .attr('x', 85).attr('y', -14)
      .attr('fill', '#757575').attr('font-size', 9).attr('text-anchor', 'end')
      .text('Plan')

      bar 
      .append('text')
      .attr('id', `PLAN_${col.name}_${this.localId}`)
      .attr('x', 85).attr('y', -2)
      .attr('fill', '#333').attr('font-size', 11).attr('text-anchor', 'end')
      .text(col.plan+'%')

      // Delta
      bar
      .append('text')
      .attr('x', this.area.barLen-1).attr('y', -14)
      .attr('fill', '#757575').attr('font-size', 9).attr('text-anchor', 'end')
      .text('Delta')

      bar 
      .append('text')
      .attr('id', `DELTA_${col.name}_${this.localId}`)
      .attr('x', this.area.barLen-1).attr('y', -2)
      .attr('fill', this.gmx_deltaValue(col.delta)).attr('font-size', 11).attr('text-anchor', 'end')
      .text(col.delta+'%')
    },

  } 
}